import { CalendarIcon, RulerIcon, ZapIcon, ShieldAlertIcon, type LucideIcon } from 'lucide-react';

export interface Bonus {
  icon: LucideIcon;
  emoji: string;
  title: string;
  value: string;
  text: string;
  detail: string;
}

export const bonuses: Bonus[] = [
  {
    icon: CalendarIcon,
    emoji: '🗓️',
    title: 'Mapa Flash de Arranque 7 Días',
    value: '14,90€',
    text: 'Una hoja de ruta de siete días para preparar el arranque: diagnóstico inicial, cuatro sesiones de inicio de 50 minutos, rúbricas y checklist de preparación. Decide qué observar, cómo organizar al grupo y qué ajustar antes de continuar.',
    detail: '20 páginas · Hoja de ruta + 4 sesiones de inicio + registros'
  },
  {
    icon: RulerIcon,
    emoji: '📐',
    title: 'Kit Visual "Mira y Pita"',
    value: '15,90€',
    text: '14 fichas visuales para consultar el montaje, lanzar la actividad y recordar qué observar. Cada ficha desarrolla un bloque de 10 minutos con esquema y variante. Incluye edición A4 para imprimir y edición móvil para consultar durante la preparación.',
    detail: '14 fichas · A4 + versión móvil del mismo contenido'
  },
  {
    icon: ZapIcon,
    emoji: '⚡',
    title: 'Scripts de Explicación en 15 Segundos',
    value: '11,90€',
    text: '24 consignas breves con la estructura Gancho + Límite + Acción, acompañadas de pautas para demostrar, comprobar la comprensión y corregir. Incluye ejemplos y una plantilla para preparar tus propias explicaciones. El formato de 15 segundos se refiere a la consigna de lanzamiento; añade la demostración y la comprobación que necesite tu grupo.',
    detail: '24 consignas · Ejemplos + plantilla'
  },
  {
    icon: ShieldAlertIcon,
    emoji: '🛑',
    title: 'Panel Anticaos del Profe de EF',
    value: '13,90€',
    text: 'Cinco señales compartidas, seis normas y ocho rutinas para organizar entradas, salidas, cambios y recogida. Incluye carteles y soportes imprimibles para recordar al grupo qué hacer en cada momento.',
    detail: '5 señales · 6 normas · 8 rutinas · Imprimibles'
  }
];
